<div>
  <phoenix-command-menu></phoenix-command-menu>
  <router-outlet></router-outlet>
</div>